import {
  DefaultPage,
  ReactCompass,
  GvmStats,
  Graph,
  ItopTable,
  ApiTest,
  GvConsumerSpeedometer,
  App,
} from './';

export default {
  path: '/',
  name: 'Home',
  childRoutes: [
    { path: 'stats',
      name: 'Gvm stats',
      component: GvmStats,
      isIndex: true,
    },
    { path: 'app', name: 'App', component: App },
    { path: 'default-page', name: 'Default-Page', component: DefaultPage },
    { path: 'react-compass', name: 'React compass', component: ReactCompass },
    { path: 'stats', name: 'Gvm stats', component: GvmStats },
    { path: 'graph', name: 'Graph', component: Graph },
    { path: 'table', name: 'Itop table', component: ItopTable },
    { path: 'apitest', name: 'Api test', component: ApiTest },
    { path: 'gvspeedometer', name: 'Gv consumer speedometer', component: GvConsumerSpeedometer },
  ],
};



// WEBPACK FOOTER //
// ./src/features/home/route.js